<template>
  <table class="contract-log-table-section">
    <thead>
      <tr class="contract-log-table-section__thead-row">
        <th v-text="$tc('MypagePage.MypageContract.logPage.date')" />
        <th v-text="$tc('MypagePage.MypageContract.logPage.detail')" />
        <th v-text="$tc('MypagePage.MypageContract.logPage.note')" />
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(log, index) in planContractLogData"
        :key="`ContractHistory${index}`"
        class="contract-log-table-section__tbody-row"
        :class="{ 'contract-log-table-section__tbody-row--is-error': log.error }"
      >
        <th v-text="log.date" />
        <td v-text="log.detail" />
        <td v-text="log.note" />
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { PlanContractLogDataType } from '@/components/MypageContractPage/hook/useMypageContractLog'

/**
 * マイページ: プラン契約履歴一覧セクション
 */
export default defineComponent({
  name: 'MypageContractLogTableSection',
  props: {
    planContractLogData: {
      type: Array as PropType<Array<PlanContractLogDataType>>,
      default: () => [],
    },
  },
})
</script>

<style lang="scss" scoped>
.contract-log-table-section {
  width: 100%;
  text-align: left;
  font-weight: 500;
  font-size: min(#{convertPXtoVW(11)}, 11px);
  line-height: 1.82;
  letter-spacing: 0.02em;
  font-feature-settings: 'palt' on;
  color: $gray75;
  table-layout: fixed;

  th,
  td {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  &__thead-row {
    th {
      padding-bottom: 6px;

      &:first-child {
        width: 90px;

        @media screen and (min-width: $responsiveTabletWidth) {
          width: 120px;
        }
      }

      &:not(:first-child) {
        padding-left: convertPXtoVW(12);
      }
    }
  }

  &__tbody-row {
    color: $black20;

    th,
    td {
      padding: 12px 0 13px;
      line-height: 1.27;
      letter-spacing: 0.04em;
    }

    th {
      white-space: pre-line;
    }

    td {
      padding-left: convertPXtoVW(12);
    }

    &--is-error {
      color: $red;
    }
  }
}
</style>
